import { DEEPFAKE_NOTIFICATIONS_POLLING_ASYNC, INCIDENTS_COUNT_POLLING_ASYNC } from './constants'

export const incidentsCountPolling = () => ({
  type: INCIDENTS_COUNT_POLLING_ASYNC.INITIATE,
})
export const incidentsCountPollingSuccess = (data) => ({
  type: INCIDENTS_COUNT_POLLING_ASYNC.SUCCESS,
  payload: { data },
})
export const incidentsCountPollingError = (error) => ({
  type: INCIDENTS_COUNT_POLLING_ASYNC.ERROR,
  error,
})

export const deepfakeNotificationsPolling = () => ({
  type: DEEPFAKE_NOTIFICATIONS_POLLING_ASYNC.INITIATE,
})
